"use client";

import { useAuthStore } from "@/store/authStore";
import { useUserStore } from "@/store/userStore";

let isLoggingOut = false;

type ForceClientLogoutOptions = {
  redirectTo?: string;
};

/**
 * Session is already dead on the server (cookies cleared).
 * Clear client UI state and navigate once.
 */
export function forceClientLogout(options: ForceClientLogoutOptions = {}) {
  if (typeof window === "undefined" || isLoggingOut) {
    return;
  }

  useAuthStore.getState().logout();
  useUserStore.getState().resetUser();

  try {
    localStorage.removeItem("auth-storage");
    localStorage.removeItem("user-storage");
  } catch {
    // Ignore storage access errors.
  }

  const pathname = window.location.pathname;
  if (pathname.startsWith("/login") || pathname.startsWith("/login-otp")) {
    return;
  }

  isLoggingOut = true;
  const redirectTo = options.redirectTo || "/login-otp";
  window.location.assign(redirectTo);
}
